angular.module('controllers').controller('foodCategoryController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter) {
		$rootScope.path = '/food-category';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'food-category';
		$scope.pathTemplate = 'food/foodcategories';
		$scope.rootPublicPath = '/images';
		$scope.title = 'Categorii / meniuri';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.additionals['categoryImagePath'] = $scope.rootPublicPath+'/food_categories';
		$scope.defaultItem = 10;
        $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'image':{'label':'Imagine', 'filter':0},
			'food_category_name':{'label':'Denumire', 'filter':1, 'filterType':'input'},
			'food_category_parent_id':{'label':'Parinte', 'filter':1, 'filterType':'select'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'food_category_name';
		$scope.dependedFields = [];
		$scope.additionals['food_categories'] =[{'id': 0, 'value': ''}];

		/* get dependent fields */
		$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {

					$scope.dependedFields.push(data);
					$scope.additionals['dependedFields'] = $scope.dependedFields[0];

					$scope.getCategoryHierarchy = $scope.additionals['makeDropDown'](data.parents, 'food_category_name');
					$scope.additionals['parents'] =[{'id': 0, 'value': '--root--'}];

					angular.forEach($scope.getCategoryHierarchy, function (item, key) {
						$scope.additionals['parents'].push({id:item.id, value:item.food_category_name});
					});
					$scope.columns.food_category_parent_id.options = $scope.additionals['parents'];

				});
		}

		$scope.additionals['searchTerm'];
		$scope.additionals['clearSearchTerm'] = function() {
			$scope.additionals['searchTerm'] = '';
		};
		$scope.additionals['onSearchChange'] = function(ev) {
			ev.stopPropagation();
		};

		$scope.additionals['functionResult'] = function(ev, data) {
			if (!angular.isUndefined($scope.modelData.food_category_name)) {
				$scope.modelData.food_category_name = $scope.additionals['formatTextResult']($scope.modelData.food_category_name);
			}

			$scope.getCategoryHierarchy = $scope.additionals['makeDropDown'](data.parents, 'food_category_name');
			$scope.additionals['parents'] =[{'id': 0, 'value': '--root--'}];
			angular.forEach($scope.getCategoryHierarchy, function (item, key) {
				$scope.additionals['parents'].push({id:item.id, value:item.food_category_name});
			});
			$scope.columns.food_category_parent_id.options = $scope.additionals['parents'];
		}

		/* multiple images */

		$scope.additionals['publicPath'] = $scope.rootPublicPath+'/food_categories';
		if($scope.action == 'media') {
			$scope.additionals['content_type'] = 'undefined';
		}
		$scope.addMediaFoodCategory = function (ev, path, model, section) {
			$scope.addMediaModel(ev, path, model, section, 'undefined');
		}

		$scope.additionals['deleteImage'] = function (ev, model, imageId, image) {
			var post = {};
			post['route'] = 'deleteImage';
			post['image'] = image;
			post['id'] = model.id;
			Crud.post('form-urlencoded', post, $scope.path + '/deleteImage')
				.success(function () {
					var position = model['media'].map(function (e) {
						return e.id;
					}).indexOf(imageId);
					delete model['media'][position];

				}).error(function (data) {
				$scope.errors = data.errors;

			});
		}
		/* end multiple images */

		$scope.additionals['function']= function(ev, data) {

		}

        /*update glovo*/
        $scope.updateGlovo = function (ev, path, model) {
            $scope.result = 2;
            if($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'updateglovo';
                $scope.actionLabel = 'Updatare Menu Glovo';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
                $scope.additionals['invalid'] = '';

                $scope.cancel = function () {
                    $scope.errors = {};
                    $scope.controlSH = false;
                };
                $scope.additionals['buttonDisabled'] = true;
                $scope.isLoading = true;
                var post = {};
                post['route'] = 'updateglovo';
                if (!angular.isUndefined(model)) {
                    post['id'] = model;
                }
                Crud.post($scope.additionals['content_type'], post, path+'/updateGlovo')
                    .success(function (data) {
                        if (!angular.isUndefined(data.invalid)) {
                            $scope.additionals['invalid'] = data.invalid;
                        } else {
                            if (!angular.isUndefined(data.transaction_id)) {
                                $scope.result = 1;
                            } else {
                                $scope.result = 0;
                            }
                        }
                        $scope.errors = {};
                        $scope.isLoading = false;
                        $scope.additionals['buttonDisabled'] = false;
                    })
                    .error(function (data) {
                        $scope.isLoading = false;
                        $scope.errors = data.errors;
                        $scope.additionals['buttonDisabled'] = false;
                    });
            }

            if($scope.mode_action == 'dialog') {
                if (!angular.isUndefined(model)) {
                    var model = model;
                }
                $scope.actionLabel = 'Updatare Menu Glovo';
                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'updateGlovoDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        model: model,
                        additionals: $scope.additionals
                    }
                }).then(function () {

                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'additionals'];

                function DialogController($scope, $mdDialog, pathTemplate, model, additionals) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.additionals = additionals;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    $scope.isLoading = true;
                    $scope.additionals['buttonDisabled'] = true;
                    var post = {};
                    post['route'] = 'updateglovo';
                    if (!angular.isUndefined(model)) {
                        post['id'] = model;
                    }
                    Crud.post($scope.additionals['content_type'], post, path + '/updateGlovo')
                        .success(function (data) {
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            } else {
                                if (!angular.isUndefined(data.transaction_id)) {
                                    $scope.result = 1;
                                } else {
                                    $scope.result = 0;
                                }
                            }
                            $scope.isLoading = false;
                            $scope.additionals['buttonDisabled'] = false;
                        })
                        .error(function (data) {
                            $scope.isLoading = false;
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                        });

                }
            }
        };
        /*end update glovo*/

	}]
)
